// extracted by mini-css-extract-plugin
export default {"loaderContent":"Loader_loaderContent__j-4Rd","loader":"Loader_loader__Fhrug","logo":"Loader_logo__TB3UB"};